import styles from '../../../pages/LeadCapture/LeadCaptureMonitor/LeadCaptureMonitor.module.css'
const ExhibitorLeadsSnapshot = ({ index, exhibitorLeadsSnapshot }) => {
    return (
        <>
            <tr className={styles.trLeadsSnapshot} key={index}>
                <td className={styles.tdLeadsSnapshot}> {exhibitorLeadsSnapshot.refNumber}</td>
                <td className={styles.tdLeadsSnapshot}> {exhibitorLeadsSnapshot.name}</td>
                <td className={styles.tdLeadsSnapshot}> {exhibitorLeadsSnapshot.organization}</td>
                <td className={styles.tdLeadsSnapshot}> {exhibitorLeadsSnapshot.leadCount}</td>
            </tr>
        </>
    );
}

export default ExhibitorLeadsSnapshot;
